import type { Messages } from '../i18n.types'

import { de } from './de'
import { en } from './en'
import { fr } from './fr'
import { hu } from './hu'

const DICTIONARIES: Record<string, Messages> = { en, de, hu, fr }

/** Languages with an admin dictionary; other site languages show English. */
export const UI_LOCALES = Object.keys(DICTIONARIES)

export function getMessages(locale: string): Messages {
  return DICTIONARIES[locale] ?? DICTIONARIES[locale.split('-')[0]] ?? en
}
